import {Action} from '@ngrx/store';
import {TermStaffAccountDTO} from '@staff-app/models/termStaffAccountDTO';
import * as fromModels from '@shared/models';

export enum UserActionTypes {
  GetLoggedInUserAndRoles = '[User] Get LoggedIn User And Roles',
  GetUserSuccess = '[User] Get User Successful',
  GetUserOnlySuccess = '[User] Get User Only Successful',
  PrepareJobAppForUser = '[User] Prepare Job App For User',
  PrepareJobAppForUserSuccess = '[User] Prepare Job App For User Successful',
  GetUserFailure = '[User] Get User Failure',
  CreateAccount = '[User] Create Account',
  CreateAccountSuccess = '[User] Create Account Success',
  DisplayLoginMessage = '[User] Display Login Message',
  DisplayLoginMessageSuccess = '[User] Display Login Message Success',
  ConsumeRafCoupon = '[User] Consume Raf Coupon',
  ConsumeRafCouponSuccess = '[User] Consume Raf Coupon Success'
}

export class GetLoggedInUserAndRoles implements Action {
  readonly type = UserActionTypes.GetLoggedInUserAndRoles;
  constructor(public continueToPrepareJobApp: boolean = true) {}
}
export class GetUserSuccess implements Action {
  readonly type = UserActionTypes.GetUserSuccess;
  constructor(public payload: fromModels.UserAndRoleInfo) {}
}
export class GetUserOnlySuccess implements Action {
  readonly type = UserActionTypes.GetUserOnlySuccess;
  constructor(public payload: fromModels.UserAndRoleInfo) {}
}
export class PrepareJobAppForUser implements Action {
  readonly type = UserActionTypes.PrepareJobAppForUserSuccess;
  constructor(public payload: number) {}
}
export class PrepareJobAppForUserSuccess implements Action {
  readonly type = UserActionTypes.PrepareJobAppForUserSuccess;
  constructor() {}
}
export class GetUserFailure implements Action {
  readonly type = UserActionTypes.GetUserFailure;
  constructor(public payload: string) {}
}
export class CreateAccount implements Action {
  readonly type = UserActionTypes.CreateAccount;
  constructor(public payload: TermStaffAccountDTO) {}
}
export class CreateAccountSuccess implements Action {
  readonly type = UserActionTypes.CreateAccountSuccess;
  constructor(public payload: any) {}
}
export class DisplayLoginMessage implements Action {
  readonly type = UserActionTypes.DisplayLoginMessage;
  constructor(public payload: number) {}
}
export class DisplayLoginMessageSuccess implements Action {
  readonly type = UserActionTypes.DisplayLoginMessageSuccess;
  constructor(public payload: string) {}
}
export class ConsumeRafCoupon implements Action {
  readonly type = UserActionTypes.ConsumeRafCoupon;
  constructor() {}
}
export class ConsumeRafCouponSuccess implements Action {
  readonly type = UserActionTypes.ConsumeRafCouponSuccess;
  constructor() {}
}

export type UserActions =
  | GetLoggedInUserAndRoles
  | GetUserSuccess
  | GetUserOnlySuccess
  | PrepareJobAppForUser
  | PrepareJobAppForUserSuccess
  | GetUserFailure
  | CreateAccount
  | CreateAccountSuccess
  | DisplayLoginMessage
  | DisplayLoginMessageSuccess
  | ConsumeRafCoupon
  | ConsumeRafCouponSuccess;
